import styles from './CtaSection.module.css'

export default function CtaSection({
  label = 'Get Started Today',
  title = 'Your journey starts\nat nexusaiweb.com',
  sub = 'One account. Every platform. From learning to placement.',
  ctaText = 'Create Free Account',
  ctaHref = 'https://pn.nexusaiweb.com/signup',
}) {
  return (
    <section className={styles.section} aria-label="Call to action">
      <div className={styles.bg} aria-hidden="true" />
      <div className={styles.content}>
        <p className="section-label">{label}</p>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.sub}>{sub}</p>
        <a
          href={ctaHref}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-cta"
        >
          {ctaText}
        </a>
        <p className={styles.note}>
          <a href="https://nexusaiweb.com" className={styles.noteLink}>nexusaiweb.com</a>
          &nbsp;·&nbsp; SkillNexus · InternNexus · PromptNexus
        </p>
      </div>
    </section>
  )
}
